import { useQuery } from '@tanstack/react-query';
import type { MeResponse } from '@dtable/shared-types';
import { apiFetch } from '../lib/api-client';
import { useAuthStore } from '../stores/auth-store';

/** /auth/me — canonical source of the actor's permissions on the client. */
export function useMe() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const setMe = useAuthStore((s) => s.setMe);

  return useQuery<MeResponse>({
    queryKey: ['auth', 'me'],
    enabled: Boolean(accessToken),
    queryFn: async () => {
      const me = await apiFetch<MeResponse>('/auth/me');
      setMe(me);
      return me;
    },
  });
}
